export default ({
  contactUsRepository,
  maps,
  auth
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      data,
      actions,
      dispatch
    } = payload

    try {
      const contactUs = await contactUsRepository.sendContactUs({
        data,
        actions,
        maps,
        dispatch,
        auth: auth()
      })

      onSuccess({ contactUs })
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
